module.exports = __webpack_public_path__ + "img/recruit_miryoku_c_img.3b155456.png";